import React from "react";
import { useState, useEffect, useRef } from "react";

const SidebarItem = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(0);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, []);

  return (
    <div
      className={`order-list__item cart-accordion${
        isOpen ? " cart-accordion--active" : ""
      }`}
    >
      <div className="cart-accordion__header" onClick={toggleAccordion}>
        <h3 className="cart-accordion__title">{title}</h3>
      </div>
      <div
        className="cart-accordion__body"
        style={{
          maxHeight: isOpen ? `${contentHeight}px` : "0",
          overflow: "hidden",
          transition: "max-height 0.3s ease-out",
        }}
        ref={contentRef}
      >
        {children}
      </div>
    </div>
  );
};

export default SidebarItem;
